export default {
  "bgGradient": "_bgGradient_1f7yq_1"
};import "ni:sha-256;s2Qrbk492FwFnzXuRq3Lf7trtedf_A-CVeSt0htj8BI";